import { Modal } from '@trackman/web-shared-components';
import './SubscriptionPromptDialog.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Crown } from 'images/icons/Crown.svg';
import { ReactComponent as Checkmark } from 'images/icons/Checkmark.svg';

type Props = {
  open: boolean;
  subscriptionPrice: number;
  onAddOnlyCertificate: () => void;
  onClose: () => void;
  handleAddToCart: () => void;
};

export const SubscriptionPromptDialog = ({ open, subscriptionPrice, onAddOnlyCertificate, onClose, handleAddToCart }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      className='subscription-prompt-modal'
      cancelBtn={{
        label: t('BuyCertificateOnly', { ns: 'webshop' }),
        onClick: onAddOnlyCertificate,
      }}
      confirmBtn={{
        label: t('UpgradeToPremium', { ns: 'webshop' }),
        onClick: () => handleAddToCart(),
        intent: 'secondary',
      }}
      onClose={onClose}
      title={t('UpgradeToPremiumAndGet50%Off', { ns: 'webshop' })}
      open={open}
    >
      <div className='subscription-prompt-card'>
        <div className='subscription-prompt-header'>
          <Crown className='subscription-prompt-header-icon' />
          <span className='subscription-prompt-card-title'>{t('UpgradeToPremiumFor', { ns: 'webshop', price: subscriptionPrice })}</span>
        </div>

        <div className='subscription-benefits-list'>
          <div className={'subscription-benefit-item'}>
            <Checkmark />
            {t('50%OffAllCertificates', { ns: 'webshop' })}
          </div>
          <div className={'subscription-benefit-item'}>
            <Checkmark />
            {t('AccessToAllChapterTests', { ns: 'webshop' })}
          </div>
          <div className={'subscription-benefit-item'}>
            <Checkmark />
            {t('OnDemandWebinars', { ns: 'webshop' })}
          </div>
        </div>
      </div>
    </Modal>
  );
};
